export const capitalize = (str: string): string => {
  const splitStr = str.toLowerCase().split(' ')
  for (let i = 0; i < splitStr.length; i += 1) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
  }
  return splitStr.join(' ')
}

export const replaceWhitespaceLowercase = (str: string): string => {
  return str?.replace(/\s+/g, '-')?.toLowerCase()
}
